module.exports = __webpack_public_path__ + "img/1598724463.41adc127.jpg";